import { useState } from "react";
import { PageHeader } from "../components/ui/PageHeader";
import { Tabs } from "../components/ui/Tabs";
import { useGatewayEvents } from "../lib/useGatewayEvents";
import { BulkUpload } from "../features/messaging/BulkUpload";
import { ComposeForm } from "../features/messaging/ComposeForm";
import { MessageHistory } from "../features/messaging/MessageHistory";

const TABS = ["Compose", "Bulk", "Sent", "Received", "Scheduled"] as const;
type Tab = (typeof TABS)[number];

export function MessagingPage() {
  const [tab, setTab] = useState<Tab>("Compose");

  // Keeps the history tabs current as the phone reports status changes, with no refresh.
  useGatewayEvents();

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        sticky
        title="Messaging"
        description="Compose and track SMS sent through your paired Android devices."
      />

      <Tabs tabs={TABS} value={tab} onChange={setTab} label="Messaging views" />

      {tab === "Compose" && <ComposeForm />}
      {tab === "Bulk" && <BulkUpload />}

      {tab === "Sent" && (
        <MessageHistory
          direction="SENT"
          emptyTitle="Nothing sent yet"
          emptyDescription="Messages you send from Compose or the public API appear here with their delivery status."
        />
      )}

      {tab === "Received" && (
        <MessageHistory
          direction="RECEIVED"
          emptyTitle="No inbound messages"
          emptyDescription="SMS your paired phone receives are uploaded here automatically."
        />
      )}

      {tab === "Scheduled" && (
        <MessageHistory
          scheduledOnly
          emptyTitle="Nothing scheduled"
          emptyDescription="Use the Send at field in Compose to queue a message for later."
        />
      )}
    </div>
  );
}
